import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'main',
    component: () => import('@/views/main/index.vue'),
    meta: { title: '深圳市数智安科技有限公司' },
    redirect: {
      name: 'index'
    },
    children: [
      {
        path: '/index',
        name: 'index',
        component: () => import('@/views/index/index.vue'),
        meta: { title: '首页' }
      },
      {
        path: '/product-center',
        name: 'product-center',
        component: () => import('@/views/product-center/index.vue'),
        meta: { title: '产品中心' }
      },
      {
        path: '/scheme',
        name: 'scheme',
        component: () => import('@/views/scheme/index.vue'),
        meta: { title: '解决方案' }
      },
      {
        path: '/partner',
        name: 'partner',
        component: () => import('@/views/partner/index.vue'),
        meta: { title: '合作伙伴' }
      },
      {
        path: '/serve',
        name: 'serve',
        component: () => import('@/views/serve/index.vue'),
        meta: { title: '技术服务' }
      },
      {
        path: '/about',
        name: 'about',
        component: () => import('@/views/about/index.vue'),
        meta: { title: '关于我们' }
      },
      {
        path: '/product-detail/:id',
        name: 'product-detail',
        component: () => import('@/views/product-detail/index.vue'),
        meta: { title: '', parent: 'product-center' }
      },
      {
        path: '/scheme-detail/:id',
        name: 'scheme-detail',
        component: () => import('@/views/scheme-detail/index.vue'),
        meta: { title: '', parent: 'scheme' }
      }
    ]
  }
]

//防止重复点击
const pushFn = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return pushFn.call(this, location).catch(err => err);
}
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
